
<template>
  <div :id="id" :options="options" class="echart-concent"></div>
</template>

<script>
import { debounce } from '@/util/debounce';
export default {
  name: 'theGraph',
  props: {
      id: {
          type: String,
          default: '',
      },
      options: {
          type: Object,
          default: () => {
              return {};
          },
      },
  },
  computed: {
      // // 用来获取和更新组件外部的值
      // imgValue: {
      //     get() {
      //         return this.img;
      //     },
      //     set(newVal) {
      //         this.$emit("setImg", newVal, this.index);
      //     },
      // },
  },
  data() {
      return {
          chartLineGraph: null,
      };
  },
  // 侦听器
  watch: {
      options: {
          deep: true,
          handler(newValue, oldValue) {
            this.$nextTick(() => {
              this.drawLineGraph(this.id, newValue);
            })
          },
      },
  },
  mounted() {
      this.drawLineGraph(this.id, this.options);

      this.resizeHandler = debounce(() => {
          if (this.chartLineGraph) {
              this.chartLineGraph.resize();
          }
      }, 100);
      window.addEventListener('resize', this.resizeHandler);
  },
  methods: {
      drawLineGraph(id, options, resetData) {
          // 再实例化之前判断防止Echart的空数据状态报错
          if (
              this.chartLineGraph != null &&
              this.chartLineGraph != '' &&
              this.chartLineGraph != undefined
          ) {
              this.chartLineGraph.dispose();
          }

          let ele = document.getElementById(id);
          this.chartLineGraph = this.$echarts.init(ele);
          this.chartLineGraph.setOption(options);
          this.chartLineGraph.on('click', (data) => {
              this.$emit('chartClick', data);
          });
      },
  },
  beforeDestroy() {
      // 防止Echart的空数据状态报错
      if (this.chartLineGraph) {
          this.chartLineGraph.clear();
      }
  },
};
</script>

<style lang="less" scoped>
.echart-concent {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  /deep/ canvas {
      width: 100% !important;
      height: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wgEchart/wgEchart.vue